module.exports = __webpack_public_path__ + "img/feature_buy_en.0de4a3d8.png";